// Theme entry: site-wide UI behavior.
// Each module is opt-in: if its target HTML doesn't exist on the page, it no-ops.
// To remove a feature, just delete its import + call.
import { initCookiebox } from './modules/cookiebox';
import { initSmoothScroll } from './modules/smooth-scroll';
import { initPageUp } from './modules/pageup';
import { initImageSwitch } from './modules/image-switch';
import { initAccordion } from './modules/accordion';
import { initDrawer } from './modules/drawer';
import { initCf7SubmitGuard } from './modules/cf7-submit-guard';
import { initScrollEffect, nudgeScrollOnLoad } from './modules/scroll-effect';
import { initScrollHint } from './modules/scroll-hint';

document.addEventListener('DOMContentLoaded', () => {
  initCookiebox();
  initSmoothScroll();
  initPageUp();
  initImageSwitch();
  initAccordion();
  initDrawer();
  initCf7SubmitGuard();
  initScrollEffect();
  initScrollHint();
});

nudgeScrollOnLoad();
